module.exports = __webpack_public_path__ + "static/media/second_image.ffefa00c.png";